import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import API_DOMAIN from "../config/config";
import Logo from "../assests/images/logo.png";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    padding: 26,
    position: "relative",
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    border: 1,
    display: "flex",
  },
  text: {
    fontSize: 13,
    fontFamily: "Times-Roman",
    textAlign: "center",
    borderBottom: 1,
    width: "100%",
  },
  headertext: {
    fontFamily: "Times-Roman",
    borderBottom: 1,
    width: "100%",
    padding: 2,
  },
  head: {
    display: "flex",
    flexDirection: "row",
    position: "absolute",
    width: "100%",
  },
  invoice: {
    fontWeight: "bolder",
    flexDirection: "row",
    fontSize: 13,
    width: "100%",
    marginLeft: "-230px",
    marginTop: "15px",
  },
  ph_no: {
    fontSize: 8,
    paddingLeft: "450px",
    flexDirection: "row",
    marginTop: "3px",
  },
  address1: {
    fontSize: 9,
    marginTop: "30px",
    width: "100%",
    flexDirection: "row",
    marginLeft: "-380px",
  },
  address2: {
    fontSize: 9,
    marginTop: "41px",
    width: "100%",
    flexDirection: "row",
    marginLeft: "-280px",
  },
  gst: {
    fontSize: 9,
    marginTop: "53px",
    width: "100%",
    flexDirection: "row",
    marginLeft: "-300px",
  },
  logo: {
    maxWidth: "60px",
    maxHeight: "60px",
  },
  logo1: {
    paddingVertical: 10,
    marginLeft: 80,
  },
  heading: {
    display: "flex",
  },
  table: {
    display: "flex",
    borderBottom: 0.5,
    padding: 6,
    justifyContent: "flex-end",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableCell: {
    flex: 4,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  producthead: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    borderBottom: 1,
  },
  producttitle: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    height: 450,
  },
  productbody: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
  },
  bodydescription: {
    marginTop: "-420px",
    height: 420,
  },
  no: {
    textAlign: "center",
    padding: 7,
  },
  noview: {
    width: "10%",
    borderRight: 1,
  },
  particular: {
    textAlign: "left",
    padding: 7,
  },
  particularview: {
    width: "25%",
    borderRight: 1,
  },
  qty: {
    textAlign: "center",
    padding: 7,
  },
  qtyview: {
    width: "13%",
    borderRight: 1,
  },
  amountview: {
    width: "15%",
    alignItems: "center",
  },
  rateinctax: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  rate: {
    width: "17%",
    textAlign: "center",
    padding: 5,
  },
  amount: {
    width: "100%",
    textAlign: "center",
    padding: 7,
  },
  footer: {
    fontSize: 9,
    display: "flex",
    justifyContent: "flex-end",
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  footerleft: {
    height: 62,
    borderBottom: 0.5,
  },
  footerCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    width: "100%",
  },
  footerBottom: {
    position: "absolute",
    bottom: 15,
    left: 26,
    right: 26,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  footerLeft: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    textAlign: "left",
    flex: 1,
  },
  footerCenter: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    textAlign: "center",
    flex: 2,
  },
  footerRight: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    textAlign: "right",
    flex: 3,
  },
  right: {
    textAlign: "right",
  },
  totalBox: {
    position: "absolute",
  },
  w70: {
    width: "72.5%",
  },
  w30: {
    width: "27.5%",
  },
  priceRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderBottom: 1,
    flexGrow: 15,
  },
  rightsidetotals: {
    marginTop: 5,
  },
  priceCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 8,
    flexGrow: 10,
    padding: 4,
    flexShrink: 1,
  },
  overall: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    padding: 5,
    flexGrow: 2.5,
    marginTop: 6,
  },
  paymentDetails: {
    marginTop: 10,
    marginBottom: 10,
  },
  paymentRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 2,
  },
  paymentMethod: {
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  paymentAmount: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "right",
  },
  signbox: {
    fontSize: 9,
    display: "flex",
  },
  signdesk: {
    height: 55,
  },
  signbill: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  customsign: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 2,
    width: "50%",
    marginTop: 0,
    flexDirection: "column",
  },
  docs: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    padding: 5,
    marginTop: 60,
    textAlign: "right",
  },
  declration: {
    fontSize: 8,
    padding: 1,
  },
  boxdetails: {
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
  },
  boxdetailss: {
    display: "flex",
    flexDirection: "row",
  },
  box: {
    fontSize: 9,
    width: "50%",
    padding: 5,
  },
  row: {
    flexDirection: "row",
    marginTop: 5,
  },
  box1label: {
    width: 70,
    fontSize: 9,
  },
  box1value: {
    flex: 1,
    fontSize: 9,
  },
  box2label: {
    width: 90,
    fontSize: 9,
  },
  box2value: {
    flex: 1,
    fontSize: 9,
  },
  box3label: {
    width: 50,
    fontSize: 9,
    marginLeft: 5,
  },
  box3value: {
    flex: 1,
    fontSize: 9,
  },
  box4label: {
    width: 90,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  box4value: {
    flex: 1,
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  box2: {
    fontSize: 9,
    width: "40.3%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 0,
  },
  brdright: { borderRight: 1 },
  brdrights: {
    borderRight: 1,
    borderBottom: 1,
    width: "59.7%",
  },
  brdrightss: { borderBottom: 1 },
  brdtop: {
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderTopStyle: "solid",
    width: "50%",
    paddingBottom: 1,
  },
  print: {
    fontSize: 9,
    textAlign: "right",
  },
  companyname: {
    fontWeight: "bold",
    fontSize: 9,
  },
  unitname: {
    width: "12%",
    textAlign: "center",
    padding: 5,
  },
  billed: {
    fontSize: 11,
    fontWeight: "bold",
  },
  boldText: {
    fontFamily: "Times-Roman",
    fontWeight: "bold",
    fontSize: 11,
  },
  ewayno: {
    marginBottom: 1,
    fontSize: 11,
    fontWeight: "bold",
  },
  stateof: {
    fontSize: 11,
    fontWeight: "bold",
  },
  remarks: {
    fontSize: 6,
  },
});

const ITEMS_PER_PAGE = 20; // Number of items per page

const Pdf = ({ data }) => {
  console.log("data", data);

  // Function to convert rupees to words
  function convertRupeesToWordsWithBreaks(amount) {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Lakh", "Crore"];

    function convertGroup(number, thousandIndex) {
      if (number === 0) return "";

      let str = "000" + number;
      str = str.slice(-3);

      const hundred = parseInt(str[0], 10);
      const ten = parseInt(str[1], 10);
      const one = parseInt(str[2], 10);

      let words = [];

      if (hundred > 0) {
        words.push(ones[hundred] + " Hundred");
      }

      if (ten === 1) {
        words.push(teens[one]);
      } else {
        if (ten > 0) {
          words.push(tens[ten]);
        }
        if (one > 0) {
          words.push(ones[one]);
        }
      }

      if (thousandIndex > 0 && words.length > 0) {
        words.push(thousands[thousandIndex]);
      }

      return words.join(" ");
    }

    function convertIntegerPart(integerPart) {
      const groups = [];
      let thousandIndex = 0;

      while (integerPart > 0) {
        groups.push(
          convertGroup(
            integerPart % (thousandIndex === 1 ? 100 : 1000),
            thousandIndex
          )
        );
        integerPart = Math.floor(
          integerPart / (thousandIndex === 1 ? 100 : 1000)
        );
        thousandIndex++;
      }

      const resultGroups = groups.reverse().filter((group) => group !== "");
      const lastGroupIndex = resultGroups.length - 1;
      const formattedGroups = resultGroups.map((group, index) =>
        index === lastGroupIndex ? group : group
      );

      return formattedGroups.join(" ");
    }

    function convertDecimalPart(decimalPart) {
      if (decimalPart === 0) {
        return "";
      }

      let paise = Math.round(decimalPart * 100);
      return convertGroup(paise, 0) + " Paise";
    }

    const integerPart = Math.floor(amount);
    const decimalPart = amount - integerPart;

    const integerWords = convertIntegerPart(integerPart);
    const decimalWords = convertDecimalPart(decimalPart);

    const result =
      integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
    return result.trim();
  }

  const [userdata, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function chunkArray(array, chunkSize) {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }

  // Calculate GST amounts
  const totalGST = Number(data.gst_amount || 0).toFixed(2);
  const isIGST = (data.gst_type || "").toLowerCase().includes("igst");
  const sgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);
  const cgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);


  // Function to format date from yyyy-mm-dd to dd-mm-yyyy
  function formatDate(dateStr) {
    if (!dateStr) return " ";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  }

  const words = convertRupeesToWordsWithBreaks(data.total);

  return (
    <Document>
      {chunkArray(data.product, ITEMS_PER_PAGE).map(
        (productChunk, pageIndex) => (
          <Page size="A4" style={styles.page} key={pageIndex}>
            <View style={styles.section}>
              <View style={styles.header}>
                <View style={[styles.headertext, styles.heading]}>
                  <View style={styles.logo1}>
                    <Image style={styles.logo} src={Logo} />
                  </View>
                  <View style={[styles.head]}>
                    <Text style={styles.ph_no}>Phone No: 9894906923</Text>
                    <Text style={styles.invoice}>KALAI CRACKERS</Text>
                    <Text style={styles.address1}>
                      1/180/B south street, Watrap- Alagapuri -Virudhunagar Rd,
                    </Text>
                    <Text style={styles.address2}>
                      valayankulam, Watrap, Tamil Nadu 626149
                    </Text>
                    <Text style={styles.gst}>GST No: 33ABDFK1425F1ZV</Text>
                  </View>
                </View>
              </View>
              {/* Table for address */}
              <View style={styles.boxdetailss}>
                <View style={[styles.box, styles.brdrights]}>
                  <View style={styles.row}>
                    <Text style={styles.box1label}>Name</Text>
                    <Text style={styles.box1value}>: {data.party_name}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box1label}>Address</Text>
                    <Text style={styles.box1value}>: {data.address}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box1label}>Mobile Number</Text>
                    <Text style={styles.box1value}>: {data.mobile_number}</Text>
                  </View>
                  {data.gst_no ? (
                    <View style={styles.row}>
                      <Text style={styles.box1label}>GSTIN</Text>
                      <Text style={styles.box1value}>: {data.gst_no}</Text>
                    </View>
                  ) : null}
                </View>
                <View style={[styles.box2, styles.brdrightss]}>
                  <View
                    style={{
                      flex: 1,
                      borderBottom: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 3,
                    }}
                  >
                    <Text>Invoice No: {data.bill_no}</Text>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 3,
                    }}
                  >
                    <Text>Date: {formatDate(data.bill_date)}</Text>
                  </View>
                </View>
              </View>
              <View style={styles.producthead}>
                <View style={[styles.producttitle]}>
                  <View style={styles.noview}>
                    <Text style={[styles.no, styles.brdrightss]}>S No</Text>
                  </View>
                  <View style={styles.particularview}>
                    <Text style={[styles.particular, styles.brdrightss]}>
                      Particular
                    </Text>
                  </View>
                  <View style={styles.qtyview}>
                    <Text style={[styles.qty, styles.brdrightss]}>Qty</Text>
                  </View>
                  <View style={styles.qtyview}>
                    <Text style={[styles.qty, styles.brdrightss]}>Unit</Text>
                  </View>
                  <View style={styles.qtyview}>
                    <Text style={[styles.qty, styles.brdrightss]}>
                      Net Rate
                    </Text>
                  </View>
                  <View style={styles.qtyview}>
                    <Text style={[styles.qty, styles.brdrightss]}>
                      Discount
                    </Text>
                  </View>
                  <View style={styles.amountview}>
                    <Text style={[styles.amount, styles.brdrightss]}>
                      Total
                    </Text>
                  </View>
                </View>
                <View style={styles.bodydescription}>
                  {(productChunk || []).map((product, index) => (
                    <View style={styles.productbody} key={index}>
                      <View style={{ width: "10%" }}>
                        <Text style={[styles.no]}>
                          {pageIndex * ITEMS_PER_PAGE + index + 1}
                        </Text>
                      </View>
                      <View style={{ width: "25%" }}>
                        <Text style={[styles.particular]}>
                          {product.product_name}
                        </Text>
                      </View>
                      <View style={{ width: "13%" }}>
                        <Text style={[styles.qty]}>{product.qty}</Text>
                      </View>
                      <View style={{ width: "13%" }}>
                        <Text style={[styles.qty]}>{product.unit_name}</Text>
                      </View>
                      <View style={{ width: "13%" }}>
                        <Text style={[styles.qty]}>{product.price_unit}</Text>
                      </View>
                      <View style={styles.qtyview}>
                        <Text style={[styles.qty]}>
                          {product.discount_rate}
                        </Text>
                      </View>
                      <View style={{ width: "15%" }}>
                        <Text style={[styles.amount]}>{product.total_amt}</Text>
                      </View>
                    </View>
                  ))}
                </View>
              </View>
              <View style={styles.boxdetails}>
                <View style={[styles.box, styles.brdright, styles.w70]}>
                  <View style={styles.row}>
                    <Text style={styles.box2label}>Branch</Text>
                    <Text style={styles.box2value}>: ERICHANATHAM</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box2label}>Bank Name</Text>
                    <Text style={styles.box2value}>: TMB</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box2label}>Account Holder Name</Text>
                    <Text style={styles.box2value}>: Kalai crackers shop</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box2label}>Account No</Text>
                    <Text style={styles.box2value}>: 456150050800109</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box2label}>IFSC</Text>
                    <Text style={styles.box2value}>: TMBL0000456</Text>
                  </View>
                </View>
                <View style={[styles.box, styles.w30]}>
                  <View style={styles.row}>
                    <Text style={styles.box4label}>Sub Total</Text>
                    <Text style={styles.box4value}>: {data.sub_total}</Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box4label}>Discount</Text>
                    <Text style={styles.box4value}>
                      : {data.discount_amount}
                    </Text>
                  </View>
                  {isIGST ? (
                    <View style={styles.row}>
                      <Text style={styles.box4label}>IGST</Text>
                      <Text style={styles.box4value}>: {totalGST}</Text>
                    </View>
                  ) : (
                    <>
                      <View style={styles.row}>
                        <Text style={styles.box4label}>SGST</Text>
                        <Text style={styles.box4value}>: {sgstAmount}</Text>
                      </View>
                      <View style={styles.row}>
                        <Text style={styles.box4label}>CGST</Text>
                        <Text style={styles.box4value}>: {cgstAmount}</Text>
                      </View>
                    </>
                  )}
                  <View style={styles.row}>
                    <Text style={styles.box4label}>
                      Packing {data.packing_percentage}%
                    </Text>
                    <Text style={styles.box4value}>
                      : {data.packing_amount}
                    </Text>
                  </View>
                  <View style={styles.row}>
                    <Text style={styles.box4label}>Grand Total</Text>
                    <Text style={styles.box4value}>: {data.total}</Text>
                  </View>
                </View>
              </View>
              <View style={styles.footer}>
                <View style={styles.priceleft}>
                  <View style={styles.priceRow}>
                    <Text style={[styles.priceCell, styles.w70]}>
                      Amount in words: {words} Only
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.signbox}>
                <View style={styles.signdesk}>
                  <View style={styles.signbill}>
                    <View style={styles.customsign}>
                      <View style={styles.row}>
                        <Text style={styles.box3label}>Transport</Text>
                        <Text style={styles.box3value}>: {data.transport}</Text>
                      </View>
                      <View style={styles.row}>
                        <Text style={styles.box3label}>No. of cases</Text>
                        <Text style={styles.box3value}>
                          : {data.no_of_cases}
                        </Text>
                      </View>
                    </View>
                    <Text style={styles.docs}>For KALAI CRACKERS SHOP</Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.footerBottom}>
              <Text style={styles.footerLeft}>E & O.E</Text>
              <Text style={styles.footerCenter}>
                Thank you for business with us!
              </Text>
              <Text style={styles.footerRight}>
                Issued using Zentexus Technologies || +91 9025148394
              </Text>
            </View>
          </Page>
        )
      )}
    </Document>
  );
};

export default Pdf;
